import axios, { AxiosInstance } from 'axios';
import { createContext, createRef, RefObject } from 'react';

interface IApiContext {
  client: RefObject<AxiosInstance | null>;
}

const client = createRef<AxiosInstance>()
client.current = axios.create()

const initialValue: IApiContext = {
  client,
};

const ApiContext = createContext<IApiContext>(initialValue);

export default ApiContext;
